import { render, staticRenderFns } from "./TabBulletinBoardHeader.vue?vue&type=template&id=3a7f6bb8"
import script from "./TabBulletinBoardHeader.vue?vue&type=script&lang=js"
export * from "./TabBulletinBoardHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports